import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { Baby, Mail, Lock } from "lucide-react";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Bentornata!");
      navigate("/");
    } catch (err) {
      setError(formatApiError(err, "Accesso fallito"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FAF6F0] flex items-center justify-center px-4" data-testid="login-page">
      <div className="w-full max-w-md animate-fade-up">
        <div className="flex flex-col items-center mb-8">
          <div className="w-16 h-16 rounded-3xl bg-[#E07A5F] flex items-center justify-center shadow-lg mb-4">
            <Baby className="w-9 h-9 text-white" />
          </div>
          <h1 className="font-heading text-3xl font-semibold text-[#3D405B]">APiccoliPassi</h1>
          <p className="text-sm text-[#6C757D] mt-1">Gestione Asilo Nido & Scuola dell'Infanzia</p>
        </div>
        <form onSubmit={submit} className="card-warm p-8 space-y-5" data-testid="login-form">
          <div>
            <label className="label-warm block mb-2">Email</label>
            <div className="relative">
              <Mail className="w-4 h-4 absolute left-4 top-1/2 -translate-y-1/2 text-[#a89a8a]" />
              <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                data-testid="login-email-input" className="input-warm pl-11" placeholder="nome@email.it" />
            </div>
          </div>
          <div>
            <label className="label-warm block mb-2">Password</label>
            <div className="relative">
              <Lock className="w-4 h-4 absolute left-4 top-1/2 -translate-y-1/2 text-[#a89a8a]" />
              <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
                data-testid="login-password-input" className="input-warm pl-11" placeholder="••••••••" />
            </div>
          </div>
          {error && <p className="text-sm text-red-600 bg-red-50 rounded-lg px-3 py-2" data-testid="login-error">{error}</p>}
          <button type="submit" disabled={loading} data-testid="login-submit-button" className="btn-warm w-full">
            {loading ? "Accesso in corso..." : "Accedi"}
          </button>
          <div className="flex items-center justify-between text-sm">
            <Link to="/forgot-password" data-testid="forgot-password-link" className="text-[#b0563a] hover:underline font-medium">
              Password dimenticata?
            </Link>
            <Link to="/genitori" data-testid="parent-portal-link" className="text-[#4a7a63] hover:underline font-medium">
              Sei un genitore?
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
}
